import { redirect } from '@tanstack/react-router';

import { isAuthenticated, isExpired, clearTokens } from './auth';

/**
 * Auth guard for protected routes.
 * Clears expired tokens and redirects to /$slug/auth if not authenticated.
 */
export function requireAuth(slug: string) {
  // SSR guard: auth functions access localStorage which isn't available during prerendering
  // During SSR, always redirect to auth; client will re-evaluate
  if (typeof window === 'undefined') {
    throw redirect({
      to: '/$slug/auth',
      params: { slug },
    });
  }

  if (isExpired()) {
    clearTokens();
  }

  if (!isAuthenticated()) {
    throw redirect({
      to: '/$slug/auth',
      params: { slug },
    });
  }
}
